import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { Icon } from 'common-components'

export const ExportDropdownContent = styled.div`
  background: ${COLORS.white};
  border-radius: 8px;
  width: 320px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  box-shadow: 0px 4px 16px 0px rgba(56, 102, 255, 0.15);
  @media (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    box-shadow: none;
  }
`

export const ExportOption = styled.div`
  padding: 16px;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background: ${COLORS.primaryExtraLight};
    border: 1px solid ${COLORS.primaryExtraDark};
    box-shadow: 0px 4px 10px rgba(56, 102, 255, 0.15);
  }
`

export const OptionHeader = styled.h1`
  color: ${COLORS.secondarySemiDark};
  font-size: 16px;
  font-weight: 600;
`

export const OptionDescription = styled.div`
  color: ${COLORS.secondary};
  font-size: 11px;
  font-weight: 500;
`

export const CrownBadgeIcon = styled(Icon)`
  display: inline-flex;
  margin-top: -1px;
`
